import domainAPI from './modules/domainAPI'

// +===========
import featureFlagServiceAPI from './modules/featureFlagServiceAPI'

const api = {
    ...featureFlagServiceAPI,
    ...domainAPI,
};

export default api;
